import { useCallback, useState } from 'react';
import { Account } from '../../state/types';
import { useSession } from '../../context/SessionContext';
import { useAccountApi } from '../../api/useAccountApi';

export const useAccountState = () => {
  const [showSignUp, setShowSignUp] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState<Account | null>(null);
  const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);
  const [accounts, setAccounts] = useState<Account[]>([]);

  const { setIsLoading } = useSession();
  const { fetchAccountsApi, addAccountApi, updateAccountApi, deleteAccountApi, resendTempPasswordApi } = useAccountApi();

  const openAddAccountModal = () => {
    setSelectedAccount(null);
    setShowSignUp(true);
  };

  const openEditAccountModal = (account: Account) => {
    setSelectedAccount(account);
    setShowSignUp(true);
  };

  const closeModal = () => {
    setSelectedAccount(null);
    setShowSignUp(false);
  };

  const fetchAccounts = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await fetchAccountsApi();
      setAccounts(data);
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setIsLoading(false);
    }
  }, [fetchAccountsApi, setIsLoading]);

  const addAccount = async (account: Partial<Account>) => {
    try {
      await addAccountApi(account);
      alert('Account added successfully!');
      await fetchAccounts();
    } catch (error) {
      alert('Error adding account.');
    }
  };

  const updateAccount = async (account: Account, _currentUser?: Account) => {
    try {
      await updateAccountApi(account);
      alert('Account updated successfully!');
      await fetchAccounts();
    } catch (error) {
      alert('Error updating account.');
    }
  };

  const deleteAccount = async (username: string) => {
    try {
      await deleteAccountApi(username);
      alert('Account deleted successfully!');
      await fetchAccounts();
    } catch (error) {
      alert('Error deleting account.');
    }
  };

  const resendTempPassword = async (username: string, email: string) => {
    try {
      await resendTempPasswordApi(username);
      alert(`Temporary password reset email sent for ${email}`);
    } catch (error) {
      alert('Failed to resend temporary password.');
    }
  };

  return {
    showSignUp,
    setShowSignUp,
    selectedAccount,
    setSelectedAccount,
    isChangePasswordOpen,
    setIsChangePasswordOpen,
    openAddAccountModal,
    openEditAccountModal,
    closeModal,
    accounts,
    fetchAccounts,
    addAccount,
    updateAccount,
    deleteAccount,
    resendTempPassword,
  };
};
